import { DataBean } from "../DataBean";

export class FixedAssetLine extends DataBean {


    public async getFixedAssetLineCatalog(idLine:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getFixedAssetLineCatalog_Number", [idLine]);
    }


    public async updateFixedAssetParams(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_updateFixedAssetParams_Number", [id]);
    }
}